
export const translations = {
  en: {
    // Header
    navServices: 'Services',
    navAbout: 'About',
    navTestimonials: 'Testimonials',
    navRequestQuote: 'Quote',

    // Hero
    heroTitle: 'Your Celebration Starts Now',
    heroSubtitle: 'We Handle the Rest',
    heroDescription: 'With the energy and expertise of Roberta Forte, Better Now turns your dream event into a perfect, worry-free reality.',
    heroCta: 'Request Your Free Quote',

    // Services
    servicesTitle: 'Events that Create Lasting Memories',
    servicesSubtitle: 'From intimate gatherings to large corporate functions, we bring your vision to life with passion and precision.',
    services: {
        weddings: { title: "Weddings & Anniversaries", description: "We take care of every detail so your 'I do' is the only focus of the day." },
        parties: { title: "Parties & Get-Togethers", description: "From kids' birthdays to major celebrations, we create vibrant and joyful atmospheres." },
        corporate: { title: "Corporate Events", description: "Product launches, team-building, and year-end parties that reflect your company's excellence." },
        sports: { title: "Sports & Leisure Events", description: "Organizing tournaments, races, and recreational activities with flawless logistics." }
    },

    // About
    aboutTitle: 'The Energy that Transforms',
    aboutSubtitle: 'Meet Roberta Forte, the soul of Better Now.',
    aboutParagraph1: `"Hi, I'm Roberta Forte, a mother of triplets and passionate about connecting people and celebrating life. My journey into event planning began organically, helping friends and the school community create special moments."`,
    aboutParagraph2: `"Today, that passion is Better Now, a company that combines my vast social network with a dedication to making your event unique and vibrant. For me, every party is a story waiting to be told."`,
    ourHistory: 'Our History',
    ourHistoryText: 'It all started with the desire to create events that truly meant something to people. Roberta Forte, with her creativity and unique vision, transformed this dream into reality, building a company that is now a reference in exclusive events for families and businesses.',
    ourMission: 'Our Mission',
    ourMissionText: 'To transform moments into unforgettable memories through exclusive events that connect people, celebrate achievements, and create stories that will be told forever.',
    ourVision: 'Our Vision',
    ourVisionText: 'To be recognized as the best event company in Brazil, a reference in quality, creativity, and the ability to create experiences that exceed all expectations.',
    passionTitle: 'Passion',
    passionText: 'We love what we do and put our heart into every detail of our events.',
    excellenceTitle: 'Excellence',
    excellenceText: 'We seek perfection in every experience, exceeding expectations.',
    connectionTitle: 'Connection',
    connectionText: 'We create moments that unite people and strengthen relationships.',
    qualityTitle: 'Quality',
    qualityText: 'Commitment to the best experience for our clients.',

    // Testimonials
    testimonialsTitle: 'Those Who Celebrated With Us, Recommend Us',
    testimonials: {
        mariana: { quote: "Roberta is incredible! She turned my kids' first birthday party into a fairytale. Contagious energy and flawless professionalism!", name: "Mariana L.", event: "Children's Birthday Party" },
        carlos: { quote: "The end-of-year party for our company was a huge success. Better Now understood our needs perfectly and delivered beyond our expectations.", name: "Carlos S.", event: "Corporate Event" },
        ana: { quote: "Our wedding was simply perfect. They took care of everything with such care and attention to detail. We could just enjoy our special day. Thank you!", name: "Ana & João", event: "Wedding" },
    },

    // Contact Form
    contactTitle: 'Ready to Plan Your Next Big Event?',
    contactSubtitle: 'Fill out the form, and our team will get in touch to create a personalized, no-obligation proposal.',
    contactForm: {
        name: 'Your Name',
        email: 'Your Email',
        phone: 'Phone / WhatsApp',
        eventType: 'Select Type of Event',
        eventTypes: [
            'Weddings & Anniversaries',
            'Parties & Get-Togethers',
            'Corporate Events',
            'Sports & Leisure Events',
            'Other'
        ],
        guests: 'Estimated Number of Guests',
        date: 'Event Date',
        message: 'Additional Message',
        submit: 'I Want an Unforgettable Event!'
    },

    // Clients Section
    clientsTitle: 'Client Management',
    clientsList: 'Clients List',
    addClient: 'Add Client',
    editClient: 'Edit Client',
    clientName: 'Name',
    clientPhone: 'Phone',
    clientWhatsapp: 'WhatsApp',
    clientEmail: 'Email',
    clientAddress: 'Address',
    contact: 'Contact',
    clientNotes: 'Notes',
    searchClients: 'Search clients...',
    filterByDate: 'Filter by date',
    exportData: 'Export Data',
    exportAll: 'Export All Clients',
    exportFiltered: 'Export Filtered Clients',
    exportSummary: 'Export Summary',
    clientHistory: 'Client History',
    addInteraction: 'Add Interaction',
    interactionType: 'Interaction Type',
    interactionDescription: 'Description',
    interactionDate: 'Date',
    viewEvents: 'View Events',
    linkEvent: 'Link Event',
    unlinkEvent: 'Unlink Event',
    clientEvents: 'Client Events',
    selectEvent: 'Select Event',
    relationshipType: 'Relationship Type',
    eventNotes: 'Event Notes',
    participant: 'Participant',
    organizer: 'Organizer',
    sponsor: 'Sponsor',
    vendor: 'Vendor',
    guest: 'Guest',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    actions: 'Actions',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    noClients: 'No clients found',
    noEvents: 'No events found',
    noInteractions: 'No interactions found',
    confirmDelete: 'Are you sure you want to delete this client?',
    clientAdded: 'Client added successfully',
    clientUpdated: 'Client updated successfully',
    clientDeleted: 'Client moved to trash successfully',
    clientRestored: 'Client restored successfully',
    clientPermanentlyDeleted: 'Client permanently deleted',
    eventLinked: 'Event linked successfully',
    eventUnlinked: 'Event unlinked successfully',
    interactionAdded: 'Interaction added successfully',
    
    // Trash Section
    trash: 'Trash',
    activeClients: 'Active Clients',
    deletedClients: 'Deleted Clients',
    restore: 'Restore',
    permanentDelete: 'Delete Permanently',
    confirmRestore: 'Are you sure you want to restore this client?',
    confirmPermanentDelete: 'Are you sure you want to permanently delete this client? This action cannot be undone.',
    deletedAt: 'Deleted At',
    noDeletedClients: 'No deleted clients found',

    // Footer
    footerCopyright: 'Better Now Produções e Eventos. All Rights Reserved.',
    footerTagline: 'Designed with passion for unforgettable celebrations.',
    contactInfo: 'Contact Information',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    businessHours: 'Business Hours',
    mondayToFriday: 'Monday to Friday',
    saturday: 'Saturday',
    closed: 'Closed',
    sundaysAndHolidays: 'Sundays and holidays: Closed',
    followUs: 'Follow Us',
    followUsInstagram: 'Follow us on Instagram'
  },
  pt: {
    // Header
    navServices: 'Serviços',
    navAbout: 'Sobre',
    navTestimonials: 'Depoimentos',
    navRequestQuote: 'Orçamento',

    // Hero
    heroTitle: 'Sua Celebração Começa Agora',
    heroSubtitle: 'Nós Cuidamos do Resto',
    heroDescription: 'Com a energia e expertise de Roberta Forte, a Better Now transforma seu evento dos sonhos em uma realidade perfeita e sem preocupações.',
    heroCta: 'Solicite Seu Orçamento Gratuito',

    // Services
    servicesTitle: 'Eventos que Criam Memórias Duradouras',
    servicesSubtitle: 'De encontros íntimos a grandes eventos corporativos, damos vida à sua visão com paixão e precisão.',
    services: {
        weddings: { title: "Casamentos & Aniversários", description: "Cuidamos de cada detalhe para que o seu 'sim' seja a única preocupação do dia." },
        parties: { title: "Festas & Confraternizações", description: "De aniversários infantis a grandes celebrações, criamos atmosferas vibrantes e alegres." },
        corporate: { title: "Eventos Corporativos", description: "Lançamentos de produtos, team-building e festas de fim de ano que refletem a excelência da sua empresa." },
        sports: { title: "Eventos Esportivos & Lazer", description: "Organização de torneios, corridas e atividades recreativas com uma logística impecável." }
    },

    // About
    aboutTitle: 'A energia que Transforma',
    aboutSubtitle: 'Conheça Roberta Forte, a alma da Better Now.',
    aboutParagraph1: `"Oi, eu sou a Roberta Forte, mãe de trigêmeos e apaixonada por conectar pessoas e celebrar a vida. Minha jornada no planejamento de eventos começou de forma orgânica, ajudando amigos e a comunidade escolar a criar momentos especiais."`,
    aboutParagraph2: `"Hoje, essa paixão é a Better Now, uma empresa que combina minha vasta rede social com uma dedicação em tornar seu evento único e vibrante. Para mim, cada festa é uma história esperando para ser contada."`,
    ourHistory: 'Nossa História',
    ourHistoryText: 'Tudo começou com o desejo de criar eventos que realmente significassem algo para as pessoas. Roberta Forte, com sua criatividade e visão única, transformou esse sonho em realidade, construindo uma empresa que hoje é referência em eventos exclusivos para famílias e empresas.',
    ourMission: 'Nossa Missão',
    ourMissionText: 'Transformar momentos em lembranças inesquecíveis através de eventos exclusivos que conectam pessoas, celebram conquistas e criam histórias que serão contadas para sempre.',
    ourVision: 'Nossa Visão',
    ourVisionText: 'Ser reconhecidos como a melhor empresa de eventos do Brasil, referência em qualidade, criatividade e capacidade de criar experiências que superam todas as expectativas.',
    passionTitle: 'Paixão',
    passionText: 'Amamos o que fazemos e colocamos o coração em cada detalhe dos nossos eventos.',
    excellenceTitle: 'Excelência',
    excellenceText: 'Buscamos a perfeição em cada experiência, superando expectativas.',
    connectionTitle: 'Conexão',
    connectionText: 'Criamos momentos que unem pessoas e fortalecem relacionamentos.',
    qualityTitle: 'Qualidade',
    qualityText: 'Compromisso com a melhor experiência para nossos clientes.',

    // Testimonials
    testimonialsTitle: 'Quem Celebrou Conosco, Recomenda',
    testimonials: {
        mariana: { quote: "A Roberta é incrível! Transformou a festa de 1 aninho dos meus filhos num conto de fadas. Energia contagiante e profissionalismo impecável!", name: "Mariana L.", event: "Aniversário Infantil" },
        carlos: { quote: "A festa de final de ano da nossa empresa foi um sucesso. A Better Now entendeu perfeitamente nossas necessidades e entregou além do esperado.", name: "Carlos S.", event: "Evento Corporativo" },
        ana: { quote: "Nosso casamento foi simplesmente perfeito. Cuidaram de tudo com tanto carinho e atenção aos detalhes. Pudemos apenas curtir o nosso dia. Obrigada!", name: "Ana & João", event: "Casamento" },
    },

    // Contact Form
    contactTitle: 'Pronto para Planejar seu Próximo Grande Evento?',
    contactSubtitle: 'Preencha o formulário e nossa equipe entrará em contato para criar uma proposta personalizada e sem compromisso.',
    contactForm: {
        name: 'Seu Nome',
        email: 'Seu Email',
        phone: 'Telefone / WhatsApp',
        eventType: 'Selecione o Tipo de Evento',
        eventTypes: [
            'Casamentos & Aniversários',
            'Festas & Confraternizações',
            'Eventos Corporativos',
            'Eventos Esportivos & Lazer',
            'Outro'
        ],
        guests: 'Número Estimado de Convidados',
        date: 'Data do Evento',
        message: 'Mensagem Adicional',
        submit: 'Quero um Evento Inesquecível!'
    },

    // Clients Section
    clientsTitle: 'Gestão de Clientes',
    clientsList: 'Lista de Clientes',
    addClient: 'Adicionar Cliente',
    editClient: 'Editar Cliente',
    clientName: 'Nome',
    clientPhone: 'Telefone',
    clientWhatsapp: 'WhatsApp',
    clientEmail: 'Email',
    clientAddress: 'Endereço',
    contact: 'Contato',
    clientNotes: 'Observações',
    searchClients: 'Buscar clientes...',
    filterByDate: 'Filtrar por data',
    exportData: 'Exportar Dados',
    exportAll: 'Exportar Todos os Clientes',
    exportFiltered: 'Exportar Clientes Filtrados',
    exportSummary: 'Exportar Resumo',
    clientHistory: 'Histórico do Cliente',
    addInteraction: 'Adicionar Interação',
    interactionType: 'Tipo de Interação',
    interactionDescription: 'Descrição',
    interactionDate: 'Data',
    viewEvents: 'Ver Eventos',
    linkEvent: 'Vincular Evento',
    unlinkEvent: 'Desvincular Evento',
    clientEvents: 'Eventos do Cliente',
    selectEvent: 'Selecionar Evento',
    relationshipType: 'Tipo de Relacionamento',
    eventNotes: 'Observações do Evento',
    participant: 'Participante',
    organizer: 'Organizador',
    sponsor: 'Patrocinador',
    vendor: 'Fornecedor',
    guest: 'Convidado',
    save: 'Salvar',
    cancel: 'Cancelar',
    delete: 'Excluir',
    edit: 'Editar',
    actions: 'Ações',
    createdAt: 'Criado em',
    updatedAt: 'Atualizado em',
    noClients: 'Nenhum cliente encontrado',
    noEvents: 'Nenhum evento encontrado',
    noInteractions: 'Nenhuma interação encontrada',
    confirmDelete: 'Tem certeza que deseja excluir este cliente?',
    clientAdded: 'Cliente adicionado com sucesso',
    clientUpdated: 'Cliente atualizado com sucesso',
    clientDeleted: 'Cliente movido para lixeira com sucesso',
    clientRestored: 'Cliente recuperado com sucesso',
    clientPermanentlyDeleted: 'Cliente excluído permanentemente',
    eventLinked: 'Evento vinculado com sucesso',
    eventUnlinked: 'Evento desvinculado com sucesso',
    interactionAdded: 'Interação adicionada com sucesso',
    
    // Trash Section
    trash: 'Lixeira',
    activeClients: 'Clientes Ativos',
    deletedClients: 'Clientes Excluídos',
    restore: 'Recuperar',
    permanentDelete: 'Excluir Permanentemente',
    confirmRestore: 'Tem certeza que deseja recuperar este cliente?',
    confirmPermanentDelete: 'Tem certeza que deseja excluir permanentemente este cliente? Esta ação não pode ser desfeita.',
    deletedAt: 'Excluído em',
    noDeletedClients: 'Nenhum cliente excluído encontrado',

    // Footer
    footerCopyright: 'Better Now Produções e Eventos. Todos os Direitos Reservados.',
    footerTagline: 'Criado com paixão por celebrações inesquecíveis.',
    contactInfo: 'Informações de Contato',
    email: 'Email',
    phone: 'Telefone',
    address: 'Endereço',
    businessHours: 'Horário de Atendimento',
    mondayToFriday: 'Segunda a Sexta',
    saturday: 'Sábado',
    closed: 'Fechado',
    sundaysAndHolidays: 'Domingos e feriados: Fechado',
    followUs: 'Siga-nos',
    followUsInstagram: 'Siga-nos no Instagram'
  },
  es: {
    // Header
    navServices: 'Servicios',
    navAbout: 'Acerca de',
    navTestimonials: 'Testimonios',
    navRequestQuote: 'Presupuesto',

    // Hero
    heroTitle: 'Tu Celebración Comienza Ahora',
    heroSubtitle: 'Nosotros Nos Encargamos del Resto',
    heroDescription: 'Con la energía y experiencia de Roberta Forte, Better Now convierte tu evento soñado en una realidad perfecta y sin preocupaciones.',
    heroCta: 'Solicita tu Presupuesto Gratuito',

    // Services
    servicesTitle: 'Eventos que Crean Recuerdos Duraderos',
    servicesSubtitle: 'Desde reuniones íntimas hasta grandes eventos corporativos, damos vida a tu visión con pasión y precisión.',
    services: {
        weddings: { title: "Bodas y Aniversarios", description: "Nos encargamos de cada detalle para que tu 'sí quiero' sea la única preocupación del día." },
        parties: { title: "Fiestas y Reuniones", description: "Desde cumpleaños infantiles hasta grandes celebraciones, creamos atmósferas vibrantes y alegres." },
        corporate: { title: "Eventos Corporativos", description: "Lanzamientos de productos, team-building y fiestas de fin de año que reflejan la excelencia de tu empresa." },
        sports: { title: "Eventos Deportivos y de Ocio", description: "Organización de torneos, carreras y actividades recreativas con una logística impecable." }
    },

    // About
    aboutTitle: 'La Energía que Transforma',
    aboutSubtitle: 'Conoce a Roberta Forte, el alma de Better Now.',
    aboutParagraph1: `"Hola, soy Roberta Forte, madre de trillizos y apasionada por conectar personas y celebrar la vida. Mi trayectoria en eventos comenzó de forma orgánica, ayudando a amigos y la comunidad escolar a crear momentos especiales."`,
    aboutParagraph2: `"Hoy, esa pasión es Better Now, una empresa que une mi amplia red de contactos con la dedicación para hacer tu evento único y vibrante. Para mí, toda fiesta es una historia por contar."`,
    ourHistory: 'Nuestra Historia',
    ourHistoryText: 'Todo comenzó con el deseo de crear eventos que realmente significaran algo para las personas. Roberta Forte, con su creatividad y visión única, transformó este sueño en realidad, construyendo una empresa que hoy es referencia en eventos exclusivos para familias y empresas.',
    ourMission: 'Nuestra Misión',
    ourMissionText: 'Transformar momentos en recuerdos inolvidables a través de eventos exclusivos que conectan personas, celebran logros y crean historias que serán contadas para siempre.',
    ourVision: 'Nuestra Visión',
    ourVisionText: 'Ser reconocidos como la mejor empresa de eventos de Brasil, referencia en calidad, creatividad y capacidad de crear experiencias que superen todas las expectativas.',
    passionTitle: 'Pasión',
    passionText: 'Amamos lo que hacemos y ponemos el corazón en cada detalle de nuestros eventos.',
    excellenceTitle: 'Excelencia',
    excellenceText: 'Buscamos la perfección en cada experiencia, superando expectativas.',
    connectionTitle: 'Conexión',
    connectionText: 'Creamos momentos que unen personas y fortalecen relaciones.',
    qualityTitle: 'Calidad',
    qualityText: 'Compromiso con la mejor experiencia para nuestros clientes.',

    // Testimonials
    testimonialsTitle: 'Quienes Celebraron con Nosotros, Nos Recomiendan',
    testimonials: {
        mariana: { quote: "¡Roberta es increíble! Transformó la fiesta del primer cumpleaños de mis hijos en un cuento de hadas. ¡Energía contagiosa y profesionalismo impecable!", name: "Mariana L.", event: "Cumpleaños Infantil" },
        carlos: { quote: "La fiesta de fin de año de nuestra empresa fue un gran éxito. Better Now entendió perfectamente nuestras necesidades y entregó más de lo esperado.", name: "Carlos S.", event: "Evento Corporativo" },
        ana: { quote: "Nuestra boda fue simplemente perfecta. Cuidaron todo con tanto cariño y atención a los detalles. Solo pudimos disfrutar nuestro día especial. ¡Gracias!", name: "Ana y João", event: "Boda" },
    },

    // Contact Form
    contactTitle: '¿Listo para Planificar tu Próximo Gran Evento?',
    contactSubtitle: 'Completa el formulario y nuestro equipo se pondrá en contacto para crear una propuesta personalizada y sin compromiso.',
    contactForm: {
        name: 'Tu Nombre',
        email: 'Tu Email',
        phone: 'Teléfono / WhatsApp',
        eventType: 'Selecciona el Tipo de Evento',
        eventTypes: [
            'Bodas y Aniversarios',
            'Fiestas y Reuniones',
            'Eventos Corporativos',
            'Eventos Deportivos y de Ocio',
            'Otro'
        ],
        guests: 'Número Estimado de Invitados',
        date: 'Fecha del Evento',
        message: 'Mensaje Adicional',
        submit: '¡Quiero un Evento Inolvidable!'
    },

    // Clients Section
    clientsTitle: 'Gestión de Clientes',
    clientsList: 'Lista de Clientes',
    addClient: 'Agregar Cliente',
    editClient: 'Editar Cliente',
    clientName: 'Nombre',
    clientPhone: 'Teléfono',
    clientWhatsapp: 'WhatsApp',
    clientEmail: 'Email',
    clientAddress: 'Dirección',
    contact: 'Contacto',
    clientNotes: 'Observaciones',
    searchClients: 'Buscar clientes...',
    filterByDate: 'Filtrar por fecha',
    exportData: 'Exportar Datos',
    exportAll: 'Exportar Todos los Clientes',
    exportFiltered: 'Exportar Clientes Filtrados',
    exportSummary: 'Exportar Resumen',
    clientHistory: 'Historial del Cliente',
    addInteraction: 'Agregar Interacción',
    interactionType: 'Tipo de Interacción',
    interactionDescription: 'Descripción',
    interactionDate: 'Fecha',
    viewEvents: 'Ver Eventos',
    linkEvent: 'Vincular Evento',
    unlinkEvent: 'Desvincular Evento',
    clientEvents: 'Eventos del Cliente',
    selectEvent: 'Seleccionar Evento',
    relationshipType: 'Tipo de Relación',
    eventNotes: 'Observaciones del Evento',
    participant: 'Participante',
    organizer: 'Organizador',
    sponsor: 'Patrocinador',
    vendor: 'Proveedor',
    guest: 'Invitado',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    actions: 'Acciones',
    createdAt: 'Creado en',
    updatedAt: 'Actualizado en',
    noClients: 'No se encontraron clientes',
    noEvents: 'No se encontraron eventos',
    noInteractions: 'No se encontraron interacciones',
    confirmDelete: '¿Estás seguro de que quieres eliminar este cliente?',
    clientAdded: 'Cliente agregado exitosamente',
    clientUpdated: 'Cliente actualizado exitosamente',
    clientDeleted: 'Cliente movido a papelera exitosamente',
    clientRestored: 'Cliente restaurado exitosamente',
    clientPermanentlyDeleted: 'Cliente eliminado permanentemente',
    eventLinked: 'Evento vinculado exitosamente',
    eventUnlinked: 'Evento desvinculado exitosamente',
    interactionAdded: 'Interacción agregada exitosamente',
    
    // Trash Section
    trash: 'Papelera',
    activeClients: 'Clientes Activos',
    deletedClients: 'Clientes Eliminados',
    restore: 'Restaurar',
    permanentDelete: 'Eliminar Permanentemente',
    confirmRestore: '¿Estás seguro de que quieres restaurar este cliente?',
    confirmPermanentDelete: '¿Estás seguro de que quieres eliminar permanentemente este cliente? Esta acción no se puede deshacer.',
    deletedAt: 'Eliminado en',
    noDeletedClients: 'No se encontraron clientes eliminados',

    // Footer
    footerCopyright: 'Better Now Producciones y Eventos. Todos los Derechos Reservados.',
    footerTagline: 'Diseñado con pasión por celebraciones inolvidables.',
    contactInfo: 'Información de Contacto',
    email: 'Email',
    phone: 'Teléfono',
    address: 'Dirección',
    businessHours: 'Horario de Atención',
    mondayToFriday: 'Lunes a Viernes',
    saturday: 'Sábado',
    closed: 'Cerrado',
    sundaysAndHolidays: 'Domingos y feriados: Cerrado',
    followUs: 'Síguenos',
    followUsInstagram: 'Síguenos en Instagram'
  }
};
